import { render, staticRenderFns } from "./lbil-users-list.html?vue&type=template&id=640bcdb0&scoped=true&external"
import script from "./lbil-users-list.js?vue&type=script&lang=js&external"
export * from "./lbil-users-list.js?vue&type=script&lang=js&external"
import style0 from "./lbil-users-list.scss?vue&type=style&index=0&id=640bcdb0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bcdb0",
  null
  
)

export default component.exports